import {
  LIST_REPORT2,
  LIST_REPORT2_SUCCESS,
  LIST_REPORT2_CLEAN,
  LIST_REPORT2_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  report: [],
}

const Report2List = (state = initialState, action) => {
  switch (action.type) {
    case LIST_REPORT2:
      state = {
        ...state,
        loading: true,
      }
      break
    case LIST_REPORT2_SUCCESS:
      state = {
        ...state,
        report: action.payload.report,
        loading: false,
        done: true,
      }
      break
    case LIST_REPORT2_CLEAN:
      state = initialState
      break
    case LIST_REPORT2_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default Report2List
